const PAGE_SIZE = 9;
const ANY_OPTION_KEY = "any";

export { PAGE_SIZE, ANY_OPTION_KEY };
